/* eslint-disable */
(function() {
  var chart, data, delimit, newchart, options, thischart;

  delimit = function(val, character) {
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, character);
  };

  (function(root, factory) {
    if (typeof define === 'function' && define.amd) {
      // AMD. Register as an anonymous module.
      define([], function() {
        return root.returnExportsGlobal = factory();
      });
    } else if (typeof exports === 'object') {
      // Node. Does not work with strict CommonJS, but
      // only CommonJS-like enviroments that support module.exports,
      // like Node.
      module.exports = factory();
    } else {
      root['Chartist.plugins.ctBarLabels'] = factory();
    }
  })(this, function() {
    /**
     * Chartist.js plugin to display a data label on top of the bars in a bar chart. Will also work if you animate the height of the bar. Also adds a thousands delimiter based on the html lang attribute.
     *
     */
    /* global Chartist */
    (function(window, document, Chartist) {
      'use strict';
      var defaultOptions;
      defaultOptions = {
        labelClass: 'ct-barlabel',
        labelOffset: {
          x: 0,
          y: -10
        },
        prefix: '',
        suffix: '',
        thousandsdelimiter: function() {
          if (document.documentElement.lang === "en") {
            return ',';
          } else {
            return '.';
          }
        }
      };
      Chartist.plugins = Chartist.plugins || {};
      return Chartist.plugins.ctBarLabels = function(options) {
        options = Chartist.extend({}, defaultOptions, options);
        return function(chart) {
          if (chart instanceof Chartist.Bar) {
            return chart.on('draw', function(data) {
              var barval, ytop;
              if (data.type === 'bar') {
                if (data.value.y !== 0 || data.value.y !== 'undefined') {
                  barval = '' + options.prefix + delimit(data.value.y, options.thousandsdelimiter) + options.suffix;
                  ytop = data.y2 ? data.y2 : data.y1;
                  data.group.elem('text', {
                    x: data.x1 + (data.element.width() * .5) + options.labelOffset.x,
                    y: ytop + options.labelOffset.y - (data.meta ? 20 : 0),
                    'text-anchor': 'middle'
                  }, options.labelClass).text(barval);
                  if (data.meta) {
                    data.group.elem('text', {
                      x: data.x1 + (data.element.width() * .5) + options.labelOffset.x,
                      y: ytop + options.labelOffset.y,
                      'text-anchor': 'middle'
                    }, options.labelClass).text(data.meta);
                  }
                }
              }
            });
          }
        };
      };
    })(window, document, Chartist);
    return Chartist.plugins.ctBarLabels;
  });
}).call(this);


// WEBPACK FOOTER //
// ./src/assets/js/ctBarLabels.js